import { DCMotorBase } from './DCMotor.gen';

/** @public */
class DCMotor extends DCMotorBase { }
export { DCMotor };